import React from 'react';
import type { WithContext, FAQPage } from 'schema-dts';
import type { Faq } from '@sbt-web/network/types';

interface Props {
  data: Faq;
}

const generateStructuredData = (data: Faq): WithContext<FAQPage> => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: data.faq.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };
};

export const FAQStructuredData = ({ data }: Readonly<Props>) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateStructuredData(data)),
      }}
    />
  );
};
